export const GET_IP_API = 'https://api.ipify.org/?format=json';
export const COGNITO_DOMAIN_NAME =
  'https://ume.auth.us-west-2.amazoncognito.com';
export const COGNITO_LOGIN_CALLBACK = 'http://localhost:3000/callback';
export const API_ENDPOINT = 'https://api.ume.games';
